import {
  LIST_INTEGRATION_API_REQUEST,
  LIST_INTEGRATION_API_SUCCESS,
  LIST_INTEGRATION_API_FAIL,
  CREATE_INTEGRATION_API_REQUEST,
  CREATE_INTEGRATION_API_SUCCESS,
  CREATE_INTEGRATION_API_FAIL,
  DETAIL_INTEGRATION_API_REQUEST,
  DETAIL_INTEGRATION_API_SUCCESS,
  DETAIL_INTEGRATION_API_FAIL,
  UPDATE_INTEGRATION_API_REQUEST,
  UPDATE_INTEGRATION_API_SUCCESS,
  UPDATE_INTEGRATION_API_FAIL,
  DELETE_INTEGRATION_API_REQUEST,
  DELETE_INTEGRATION_API_SUCCESS,
  DELETE_INTEGRATION_API_FAIL,
  REGENERATE_INTEGRATION_API_REQUEST,
  REGENERATE_INTEGRATION_API_SUCCESS,
  REGENERATE_INTEGRATION_API_FAIL,
  LIST_SYNC_LOG_REQUEST,
  LIST_SYNC_LOG_SUCCESS,
  LIST_SYNC_LOG_FAIL,
  RESET_INTEGRATION_API,
  LIST_MAPPING_INTEGRATION_REQUEST,
  LIST_MAPPING_INTEGRATION_SUCCESS,
  LIST_MAPPING_INTEGRATION_FAIL,
  CREATE_MAPPING_INTEGRATION_REQUEST,
  CREATE_MAPPING_INTEGRATION_SUCCESS,
  CREATE_MAPPING_INTEGRATION_FAIL,
  LIST_SUMMARY_INTEGRATION_REQUEST,
  LIST_SUMMARY_INTEGRATION_SUCCESS,
  LIST_SUMMARY_INTEGRATION_FAIL,
  LIST_ITEMS_SUMMARY_REQUEST,
  LIST_ITEMS_SUMMARY_SUCCESS,
  LIST_ITEMS_SUMMARY_FAIL
} from '../../../constants/settings/integration-api'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingRegenerate: false,
  loadingSyncLog: false,
  loadingSummary: false,
  loadingItemsSummary: false,
  syncLogList: [],
  integrationApiList: [],
  mappingIntegrationList: [],
  integrationApiDetail: {},
  summaryBussinessIntegration: [],
  itemsSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const manualInsert = (data, newData) => {
  const newState = data.map((item) => {
    if (item.id === newData.id) {
      return newData
    }
    return item
  })

  return newState
}

const listIntegrationApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_INTEGRATION_API_REQUEST:
      return { ...state, loading: true }
    case LIST_INTEGRATION_API_SUCCESS:
      return {
        ...state,
        loading: false,
        integrationApiList: action.payload,
        pageable: action.pageable
      }
    case LIST_INTEGRATION_API_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_SYNC_LOG_REQUEST:
      return { ...state, loadingSyncLog: true }
    case LIST_SYNC_LOG_SUCCESS:
      return {
        ...state,
        loadingSyncLog: false,
        syncLogList: action.payload,
        pageable: action.pageable
      }
    case LIST_SYNC_LOG_FAIL:
      return {
        ...state,
        loadingSyncLog: false,
        error: action.payload
      }
    case CREATE_INTEGRATION_API_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_INTEGRATION_API_SUCCESS:
      if (state.integrationApiList.length === action.payload.rowsPerPage) {
        return {
          ...state,
          loadingCreate: false,
          integrationApiList: [
            action.payload,
            ...state.integrationApiList.slice(0, action.payload.rowsPerPage - 1)
          ]
        }
      } else {
        return {
          ...state,
          loadingCreate: false,
          integrationApiList: [action.payload, ...state.integrationApiList]
        }
      }
    case CREATE_INTEGRATION_API_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_INTEGRATION_API_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_INTEGRATION_API_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        integrationApiDetail: action.payload
      }
    case DETAIL_INTEGRATION_API_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_INTEGRATION_API_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_INTEGRATION_API_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        integrationApiList: manualInsert(
          state.integrationApiList,
          action.payload
        )
      }
    case UPDATE_INTEGRATION_API_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case REGENERATE_INTEGRATION_API_REQUEST:
      return { ...state, loadingRegenerate: true, error: '' }
    case REGENERATE_INTEGRATION_API_SUCCESS:
      return {
        ...state,
        loadingRegenerate: false,
        error: '',
        integrationApiList: manualInsert(
          state.integrationApiList,
          action.payload
        )
      }
    case REGENERATE_INTEGRATION_API_FAIL:
      return {
        ...state,
        loadingRegenerate: false,
        error: action.payload
      }
    case DELETE_INTEGRATION_API_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_INTEGRATION_API_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_INTEGRATION_API_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_INTEGRATION_API:
      return { ...state, loading: false, error: null }
    case LIST_MAPPING_INTEGRATION_REQUEST:
      return { ...state, loading: true }
    case LIST_MAPPING_INTEGRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        mappingIntegrationList: action.payload,
        pageable: action.pageable
      }
    case LIST_MAPPING_INTEGRATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_MAPPING_INTEGRATION_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_MAPPING_INTEGRATION_SUCCESS:
      return { ...state, loadingCreate: false, error: '' }
    case CREATE_MAPPING_INTEGRATION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case LIST_SUMMARY_INTEGRATION_REQUEST:
      return {
        ...state,
        loadingSummary: true
      }
    case LIST_SUMMARY_INTEGRATION_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        summaryBussinessIntegration: action.payload
      }
    case LIST_SUMMARY_INTEGRATION_FAIL:
      return {
        ...state,
        loadingSummary: false,
        summaryBussinessIntegration: [],
        error: action.payload
      }
    case LIST_ITEMS_SUMMARY_REQUEST:
      return {
        ...state,
        loadingItemsSummary: true
      }
    case LIST_ITEMS_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingItemsSummary: false,
        itemsSummary: action.payload
      }
    case LIST_ITEMS_SUMMARY_FAIL:
      return {
        ...state,
        loadingItemsSummary: false,
        itemsSummary: [],
        error: action.payload
      }
    default:
      return state
  }
}

export default listIntegrationApiReducer
